import { Component, effect, ElementRef, inject, input, model, OnInit, output, viewChild } from '@angular/core';
import {
  VoiceRecorderComponent,
  GenericDropdownComponent,
  LookupsService,
  DropdownData,
  BtnLoaderDirective
} from '@zayan-erp/shared';
import { ReactiveFormsModule } from '@angular/forms';
import { NotesService, RecordingToUpdate } from '@zayan-erp/sales';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-notes',
  imports: [VoiceRecorderComponent, ReactiveFormsModule, GenericDropdownComponent, NgbTooltip, BtnLoaderDirective],
  standalone: true,
  templateUrl: './notes.component.html'
})
export class NotesComponent {
  #notesService = inject(NotesService);
  #lookupsService = inject(LookupsService);

  noteTypes = toSignal(this.#lookupsService.readNoteTypes(), { initialValue: [] });
  constructor() {
    effect(() => {
      if (this.noteTypes()?.length) {
        const currentType = this.form.get('noteTypeId')?.value;
        if (!currentType) {
          this.form
            .get('noteTypeId')
            ?.setValue(this.noteTypes()?.find(noteType => noteType.firstLabel === 'GENERAL')?.id ?? null);
        }
      }
    });
  }

  reset: boolean = false;
  form = this.#notesService.form;
  recordingToUpdate = model<RecordingToUpdate | null>(null);
  addNotesModal = viewChild.required<ElementRef>('addNotesModal');
  saveNote = output<void>();

  onRecordingSaved(event: { s3Key: string; documentId: string }) {
    this.form.get('s3DocumentId')?.setValue(event.documentId);
  }

  saveNotes() {
    if (!this.form.invalid) {
      this.saveNote.emit();
      this.reset = !this.reset;
    }
  }

  cancelNotes() {
    const selectedNoteTypeId = this.form.get('noteTypeId')?.value ?? null;
    this.form.reset({
      noteTypeId: selectedNoteTypeId,
      note: null,
      s3DocumentId: null
    });
    this.reset = !this.reset;
    this.recordingToUpdate.set(null);
  }

  removeRecording() {
    this.form.get('s3DocumentId')?.setValue(null);
  }
}
